import { domainUrl } from '../constants';

export const API_GET_POST_PROMOTIONS = `${domainUrl}promotions`;
export const API_GET_UPDATE_DELETE_PROMOTION = `${domainUrl}promotions/{id}`;
export const API_GET_PRODUCTS_IN_PROMOTION = `${domainUrl}promotions/{id}/products`;
